export const getSortData = () => {
  return JSON.parse(sessionStorage.getItem("supers-sort-data"));
};

export const getSortOrder = (sortOrder: number) => {
  return sortOrder < 0 ? "-" : "";
};
